import { Component, OnInit } from '@angular/core';
import { BillersService } from '../../../services/billers.service'
import { Router } from '@angular/router';


@Component({
  selector: 'app-biller3',
  templateUrl: './biller3.component.html',
  styleUrls: ['./biller3.component.scss']
})
export class Biller3Component implements OnInit {

  limit_error

  constructor(public billerService : BillersService, public router : Router) { }

  ngOnInit(): void {
    this.billerService.confirm = true
    this.billerService.complete = false
    this.billerService
    .transaction_error
    .subscribe(
      (error) => {

        this.limit_error = error;

      console.log("Princy mam happy ", error);
    })
    //console.log(this.billerService.finalData)
  }
}
